class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    var cartOverlay = document.querySelector(".cart-overlay");
    cartOverlay.addEventListener('click', this.close.bind(this));

    // Add event listener for links in the cart drawer
    this.addLinkListeners();
  }

  // Add event listeners to all links in the cart drawer
  addLinkListeners() {
    // Remove any existing click listener to prevent duplicates
    this.removeEventListener('click', this._handleCartDrawerClick);
    
    // Create a handler function for click events using event delegation
    this._handleCartDrawerClick = (event) => {
      const target = event.target.closest('a');
      
      // If the click didn't happen on or within an anchor, ignore it
      if (!target) return;
      
      // Always close for product links, collection links, checkout links
      const href = target.getAttribute('href');
      const isProductLink = href && 
        (href.includes('/products/') || 
         href.includes('/collections/') || 
         target.closest('.cart-item') && !target.classList.contains('cart-remove-button'));
      
      const isCheckoutLink = target.classList.contains('cart__checkout-button') || 
                            (href && href.includes('/checkout'));
      
      // These classes should not close the drawer
      const preventCloseClasses = ['quantity__button', 'share-button', 'cart-remove-button', 'drawer__close'];
      const shouldPreventClose = preventCloseClasses.some(className => target.classList.contains(className)) || 
                               target.hasAttribute('data-quantity-button') || 
                               target.hasAttribute('name');
      
      // Check if this is a link that should close the drawer
      if ((isProductLink || isCheckoutLink || (href && !href.startsWith('#'))) && !shouldPreventClose) {
        this.close();
      }
    };
    
    // Add the delegated click event listener to the cart drawer
    this.addEventListener('click', this._handleCartDrawerClick);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      gsap.set('cart-drawer.drawer',{ xPercent:100, autoAlpha:1 });
      this.classList.add('active');
      gsap.to('cart-drawer.drawer',{ xPercent:0, autoAlpha:1, duration:1 })
      var cartOverlay = document.querySelector(".cart-overlay");
      gsap.to(cartOverlay,{ autoAlpha:1, duration:1 })

      // Apply link listeners to close cart when navigating
      this.addLinkListeners();
    });
    setTimeout(() => {
      
      var allMqs = document.querySelectorAll(".product_title_cart_marquee_inner");
      allMqs.forEach(( mq ) => {
        if( !mq.classList.contains("marqueeLoaded") ){
          mq.classList.add("marqueeLoaded");
          console.log("ff");
          var productTitlesAll = mq.querySelectorAll(".product_title_cart_marquee_part");
          productTitlesAll.forEach(( tile ) => {
            const loop = horizontalLoop(tile, {
              repeat: -1,
              paused: false,
            });
          });
        }
      })

      /*var cartShareItems = document.querySelectorAll(".cart-item__quantity");
      cartShareItems.forEach(( shareItem ) => {
        var copyButton = shareItem.querySelector('.copy-link ');
        var shareDialog = shareItem.querySelector(".share-dialog");
        var shareButton = shareItem.querySelector(".share-button");
        shareButton.addEventListener("click", function(e){
           e.preventDefault();
          cartShareItems.forEach(( shareItemRc ) => {
            var shareDialogRc = shareItemRc.querySelector(".share-dialog");
            var shareButtonRc = shareItemRc.querySelector(".share-button");
            shareButtonRc.classList.remove("active");
            shareDialogRc.classList.remove("active");
          })
          if( shareButton.classList.contains("active") )
          {
            shareButton.classList.remove("active");
            shareDialog.classList.remove("active");
          }
          else
          {
            copyButton.innerHTML = "Copy link";
            shareDialog.classList.add("active");
            shareButton.classList.add("active")
          }
        })
        var closeButton = shareItem.querySelector(".close-button");
        closeButton.addEventListener("click", function(e){
           e.preventDefault();
          shareButton.classList.remove("active");
          shareDialog.classList.remove("active");
        })
        var textToCopy = shareItem.querySelector('.pen-url');
        copyButton.addEventListener('click', function (e) {
          e.preventDefault();
          navigator.clipboard.writeText(textToCopy.textContent).then(function () {
            copyButton.innerHTML = "Copied";
          }).catch(function (err) { });
        });
        
      })*/
      var cartShareItems = document.querySelectorAll(".cart-item__quantity");
      cartShareItems.forEach(( shareItem ) => {
        var shareButton = shareItem.querySelector(".share-button");
        shareButton.classList.remove("active");
        var textToCopy = shareItem.querySelector('.pen-url');
        var shareCopyText = shareItem.querySelector(".share-copy-text");
        gsap.set(shareCopyText,{ yPercent: 100, autoAlpha:0 });
        shareButton.addEventListener("click", function(e){
          e.preventDefault();
          if( !shareButton.classList.contains("active") )
          {
            cartShareItems.forEach(( shareItemRc ) => {
              var shareButtonRc = shareItemRc.querySelector(".share-button");
               var shareCopyTextRc = shareItemRc.querySelector(".share-copy-text");
              gsap.to(shareCopyTextRc,{ yPercent: 100, autoAlpha:0 });
              shareButtonRc.classList.remove("active");
            })
            shareButton.classList.add("active");
            navigator.clipboard.writeText(textToCopy.textContent).then(function () {
                gsap.to(shareCopyText,{ yPercent: 0, autoAlpha:1 })
            }).catch(function (err) {
            });
          }
        })
      })
      
    },1000);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    //console.log("CloseCart");
    var thisEle = this;
    gsap.to('cart-drawer.drawer',{ xPercent:100, autoAlpha:1, duration:1, onComplete:function(){
      thisEle.classList.remove('active');
    } })
    var cartOverlay = document.querySelector(".cart-overlay");
    gsap.to(cartOverlay,{ autoAlpha:0, duration:1 })
    
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Make sure we add link listeners to the new content
      this.addLinkListeners();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);